// @TODO to refactor this with object literals maybe
jQuery(function() {
    // Add listener for 'a' element which have jump link to inline page element

    jQuery('.js-jump-link').on('click', function(e) {
        e.preventDefault();

        const stickyNavHeight =
            jQuery('.top .main-header').height() +
            jQuery('.top .info-bar').height();

        var elem = jQuery(this);

        // Find target element by 'a' data attribute
        var targetElem = jQuery('.' + elem.attr('data-target-class'));

        // Check target element exists within page
        if (targetElem.length) {
            var targetPosition = targetElem.offset().top - stickyNavHeight - 10;

            // Target exists so animate page to scroll down/up to target
            jQuery('html, body').animate({scrollTop: targetPosition}, 2000);
        }
    });
});